
<div class="container">
    <div class="in_right">
    </div>
    <div class="box-left">
        <div class="logo">
            <i class="far fa-user"></i>
            <header>Join Meeting</header>
        </div>
        <div class="in_left">
            
            
            <input type="text" name="meetingID" placeholder="meetingID" [(ngModel)]="meetingID"/>
          
            <small></small>
            <input type="password" name="password" placeholder="Password" [(ngModel)]="password"/>
            <small></small>
            <input type="button" value="Join Meeting" (click)="onJoinMeeting()" style="color:aliceblue"/>
        </div>
        
    </div>
   
    <div class="in_right">
    </div>
    <div class="box-right">
     
        
    </div>

</div>